'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('mobileListController', function(orderService, jobService, docketService, userService, $rootScope, $location, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $window) {

    /***************************/
    /***** Setup Variables *****/
    /***************************/
    $scope.moment = moment;
    $scope.currentState = $state.current;
    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.hasSampleCompany = accessControl.hasSampleCompany();

    // Tab bar stuff
    $scope.listView = $state.current.data.listView;

    mixpanel.track("Opened " + $scope.listView + " Mobile");

    $scope.preventDocketsLoad = true;
    $scope.preventJobsLoad = true;
    $scope.preventOrdersLoad = true;
    $scope.preventFilingLoad = true;

    $scope.unverifiedEmail = undefined;
    $scope.unverifiedPhone = undefined;

    // Filters initial
    $scope.docketFilters = {};
    $scope.docketFilters.otherParty = "All";
    $scope.docketFilters.statusTab = "All";
    $scope.docketFilters.status = "All";
    $scope.docketFilters.organisation = "All";
    $scope.docketFilters.fromDate = null;//moment().subtract(7,'days').toDate();
    $scope.docketFilters.toDate = null;
    $scope.docketFilters.customerGroup = null;
    $scope.docketFilters.supplierGroup = null;
    $scope.docketFilters.limit = 10;
    $scope.docketFilters.offset = 0;
    $scope.docketsLoadingError = null;

    $scope.jobFilters = {};
    $scope.jobFilters.status = 'All';
    $scope.jobFilters.startFromDate = null;// moment().subtract(7,'days').toDate();
    $scope.jobFilters.startToDate = null;
    $scope.jobFilters.endFromDate = null;//moment().subtract(7,'days').toDate();
    $scope.jobFilters.endToDate = null;
    $scope.jobFilters.customer = 'All';
    $scope.jobFilters.assignee = 'All';
    $scope.jobFilters.assigneeList = [];
    $scope.jobFilters.limit = 10;
    $scope.jobFilters.offset = 0;
    $scope.jobsLoadingError = null;

    $scope.orderFilters = {};
    $scope.orderFilters.status = 'All';
    $scope.orderFilters.startFromDate = null;// moment().subtract(7,'days').toDate();
    $scope.orderFilters.startToDate = null;
    $scope.orderFilters.endFromDate = null;//moment().subtract(7,'days').toDate();
    $scope.orderFilters.endToDate = null;
    $scope.orderFilters.customer = 'All';
    $scope.orderFilters.assignee = 'All';
    $scope.orderFilters.assigneeList = [];
    $scope.orderFilters.limit = 10;
    $scope.orderFilters.offset = 0;
    $scope.ordersLoadingError = null;

    $scope.filingFilters = {};
    $scope.filingFilters.status = null;//"accepted";
    $scope.filingFilters.statusTab = "All";
    $scope.filingFilters.fromDate = null;//moment().subtract(7,'days').toDate();
    $scope.filingFilters.toDate = null;
    $scope.filingFilters.limit = 10;
    $scope.filingFilters.offset = 0;
    $scope.filingLoadingError = null;

    //if the user doesn't have any verified principals, when we should display a banner
    //telling them their account is unverified
    if ($scope.currentUser.unverifiedPrincipals) {
      const unverifiedOverlap = $scope.currentUser.emailAddresses.filter((address) => {
        return $scope.currentUser.unverifiedPrincipals.indexOf(address) === -1;
      })
      if (unverifiedOverlap.length === 0) {
        //all their principals are waiting validation - show a banner appropiate for the first principal
        //i.e. email principal requires them to check their email inbox
        //phone number requires them to visit the my account area to validate
        const target = $scope.currentUser.unverifiedPrincipals[0];
        if (target.indexOf('users.docketbook.io') !== -1) {
          //its a phone number
          $scope.unverifiedPhone = "0" + target.split('@')[0].substring(3);
        } else {
          $scope.unverifiedEmail = target;
        }
      }
    }

    // Include responsive utilities and UI Functionality
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    $scope.userCanDoAction = userService.userCanDoAction;

    /******** TEST ORG SCOPE *********/
    $scope.organisations = accessControl.allowedOrganisations();

    $rootScope.$on('OrganisationsListRefreshed', function() {
      $scope.organisations = accessControl.allowedOrganisations();
    });

    $scope.onboardingSessions = accessControl.onboardingSessions();

    $rootScope.$on('ScopeUpdated', function() {
      $scope.currentOrg = accessControl.currentOrg();
      $scope.currentOrgGroup = accessControl.currentOrgGroup();
      $scope.hasSampleCompany = accessControl.hasSampleCompany();
      $scope.isSampleCompany = accessControl.isSampleCompany();
      $scope.closeScopeDropdown();
    });

    $scope.goToMyDocketbook = function() {
      $state.go('main.dockets')
    }

    $scope.goToOnbboardingSession = function (session) {
      window.location.href = `/onboarding/${session == undefined ? '' : session.id}`
    }

    $scope.showWaitToBeInvitedModal = function() {
      $('#waitToBeInvitedModal').fadeIn(100)
    }

    $scope.closeWaitToBeInvitedModal = function() {
      $('#waitToBeInvitedModal').fadeOut(100)
    }


    /* Create a new company */
    $scope.newCompany = function(isSampleCompany) {
      $scope.closeScopeDropdown();
  		$scope.createNewCompanyFromParent(isSampleCompany, function(newOrg) {
  			if ( newOrg != null ) {
  				$state.go('main.groupDashboard', {orgId: newOrg.id});
  			}
  		});
  	}

    /*** My Docketbook Active Jobs/Dockets Feed List ***/
    $scope.loadActiveFeed = function() {
      if ( $scope.listView == 'feed' && $scope.currentOrg == null ) {
        jobService.getJobs({activeDate:moment().format('YYYY-MM-DD'),limit:2}, function(jobsList) {
          $scope.activeJobsToday = jobService.parseJobs(jobsList);
          jobService.populateJobDetails($scope.activeJobsToday, function() {
          });
        }, function(err) {
          $scope.activeJobsToday = [];
        });
        jobService.getJobs({activeDate:moment().add(1,'days').format('YYYY-MM-DD'), limit:2}, function(jobsList) {
          $scope.activeJobsTomorrow = jobService.parseJobs(jobsList);
          jobService.populateJobDetails($scope.activeJobsTomorrow, function() {
          });
        }, function(err) {
          $scope.activeJobsTomorrow = [];
        });
        docketService.getDockets({date:moment().format('YYYY-MM-DD'), limit: 2}, function(docketsList) {
          $scope.activeDocketsToday = docketService.parseDockets(docketsList);
          docketService.populateDocketsForFeed($scope.activeDocketsToday, function() {
          });
        }, function(err) {
          $scope.activeDocketsToday = [];
        });
        docketService.getDockets({date: moment().add(1,'days').format('YYYY-MM-DD'), limit: 2}, function(docketsList) {
          $scope.activeDocketsTomorrow = docketService.parseDockets(docketsList);
          docketService.populateDocketsForFeed($scope.activeDocketsTomorrow, function() {
          });
        }, function(err) {
          $scope.activeDocketsTomorrow = [];
        });
      }
    }

    $scope.loadActiveFeed();

    /*** ORG SCOPE FUNCTIONS - FOR MOBILE ****/
    $scope.openScopeDropdown = function() {
      $(".mobileSideNav").animate({
        left: "0px"
      },400);
      /*$("body").addClass('noscroll');*/
    }

    $scope.closeScopeDropdown = function() {
      $(".mobileSideNav").animate({
        left: "-90%"
      },400);
      /*$("body").removeClass('noscroll');*/
    }

    $scope.openOrgUnits = function(orgId) {
      if ( $("#org" + orgId + " ul.inner").css('display') == 'none' ) {
        $("#org" + orgId + " ul.inner").slideDown();
      } else {
        $("#org" + orgId + " ul.inner").slideUp();
      }
    }

    $scope.openUserDropdown = function() {
      if ( $(".userDropdown").css('display') == 'none' ) {
        $(".userDropdown").slideDown();
        $(".currentUserControl").addClass('open');
      } else {
        $(".userDropdown").slideUp();
        $(".currentUserControl").removeClass('open');
      }
    }

    $scope.changeOrganisation = function(org) {
      if ( org != null ) {
        var locatedOrgGroup = null;
        for ( var i = 0; i < org.groups.length; i++ ) {
          if ( org.groups[i].parent == null ) {
            locatedOrgGroup = org.groups[i];
            break;
          }
        }
        if ( locatedOrgGroup == null && org.groups && org.groups.length > 0 ) {
          locatedOrgGroup = org.groups[0];
        }
        $scope.changeOrganisationGroup(org, locatedOrgGroup);
      } else {
        $state.go('main.dashboard');
      }
    }

    $scope.changeOrganisationGroup = function(org, orgGroup) {
      accessControl.getOrgPagePermissions(org, orgGroup, function(res) {
        var permissions = res.permissions[$scope.currentUser.id];
        if ( permissions.indexOf('group-owner') != -1 || permissions.indexOf('global-administrator') != -1 ) {
          $state.go('main.groupOrders', {orgId: org.id, groupId: orgGroup.id});
        } else if ( permissions.indexOf('io.docketbook.ojdapi.getOrder') != -1 ) {
          $state.go('main.groupOrders', {orgId: org.id, groupId: orgGroup.id});
        } else if ( permissions.indexOf('io.docketbook.ojdapi.getJob') != -1 || permissions.indexOf('io.docketbook.ojdapi.getMyJob') != -1 ) {
          $state.go('main.groupJobs', {orgId: org.id, groupId: orgGroup.id});
        } else if ( permissions.indexOf('io.docketbook.ojdapi.getDocket') != -1 || permissions.indexOf('io.docketbook.ojdapi.getMyDocket') != -1 ) {
          $state.go('main.groupDockets', {orgId: org.id, groupId: orgGroup.id});
        } else {
          $state.go('main.groupDashboard', {orgId: org.id, groupId: orgGroup.id});
        }
      });
    }

    $scope.logout = function() {
      window.location.href = "/v1/logout";
    }

    /******** END TEST ORG SCOPE STUFF ************/
    /*************************/
    /***** Intercom JS API  **/
    /*************************/

    $scope.openIntercom = function() {
      window.FreshworksWidget('open', 'ticketForm')
    }

    /***********************/
    /***** Permissions *****/
    /***********************/

    /* F/E Permission Checking */
    $scope.userHasPermission = function(permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    /**************************************************************************/
    /********************************** Dockets *******************************/
    /**************************************************************************/

    /*************************************/
    /***** Docket List View Controls *****/
    /*************************************/

    // Load Dockets Into List Controller
    $scope.loadDocketsIntoList = function() {
      $scope.docketsLoadingError = null;
      $scope.prepareForDocketsFromParent();
      $scope.getDocketsListFiltered(function(docketsList) {
        var docketsListParsed = docketService.parseDockets(docketsList);
        $scope.loadDocketsListFromParent(docketsListParsed);
        $scope.preventDocketsLoad = false;
      }, function(err) {
        $scope.docketsLoadingError = err;
        $scope.preventDocketsLoad = false;
      });
    }

    // Load more dockets into list
    $scope.loadNextPageOfDockets = function(cb) {
      if ( $scope.preventDocketsLoad ) {
        cb();
        return;
      } else {
        $scope.docketFilters.offset = $scope.docketFilters.offset + $scope.docketFilters.limit;
        // get the next page of dockets
        $scope.getDocketsListFiltered(function(docketsList) {
          if ( docketsList.length == 0 ) {
            $scope.preventDocketsLoad = true;
            cb();
            return;
          }
          var docketsListParsed = docketService.parseDockets(docketsList);
          $scope.loadAdditionalDocketsFromParent(docketsListParsed);
          $scope.preventDocketsLoad = false;
          cb();
        });
      }
    }

    // When child (listController) controller is ready - load initial list of dockets
    $scope.docketsChildControllerReady = function() {
      if ( $scope.listView == 'dockets' ) {
        $scope.loadDocketsIntoList();
        $scope.bindScrollWatcher();
      }
    }

    // Get dockets
    $scope.getDocketsListFiltered = function(successCb, failureCb) {
      var params = {};
      if ( $scope.docketFilters.fromDate != null ) {
        var fromDate = moment($scope.docketFilters.fromDate);
        fromDate.set({'hour':'0','minute':'0','second':'1'});
        params.fromDate = fromDate.toISOString();
      }
      if ( $scope.docketFilters.toDate != null ) {
        var toDate = moment($scope.docketFilters.toDate);
        toDate.set({'hour':'23','minute':'23','second':'59'});
        params.toDate = toDate.toISOString();
      }
      if ( $scope.docketFilters.status != 'All' ) {
        params.status = $scope.docketFilters.status;
      }
      if ( $scope.docketFilters.customerGroup != null ) {
        params.customerGroup = $scope.docketFilters.customerGroup;
      }
      if ( $scope.docketFilters.supplierGroup != null ) {
        params.supplierGroup = $scope.docketFilters.supplierGroup;
      }
      if ( $scope.docketFilters.otherParty != 'All' ) {
        if ( $scope.docketFilters.otherParty.organisationGroup != null ) {
          params.otherParty = $scope.docketFilters.otherParty.organisationGroup;
        } else {
          var parsed = JSON.parse($scope.docketFilters.otherParty);
          if ( parsed.organisationGroup ) {
            params.otherParty = parsed.organisationGroup;
          } else {
            params.otherParty = parsed.id;
          }
        }
      }

      params['sort'] = 'date';
      params['limit'] = $scope.docketFilters.limit;
      params['offset'] = $scope.docketFilters.offset;

      docketService.getDockets(params, function(response) {
        successCb(response);
      }, function(err) {
        failureCb("Error Loading Dockets");
        return;
      });
    }

    /********************************/
    /****** Docket Data Helpers *****/
    /********************************/

    $scope.deleteDocketSwipe = function(docket) {
      // confirm docket deletion before calling to service
      swal({
        title: "Are you sure?",
        text: "You will not be able to recover this docket!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel plx!",
        closeOnConfirm: false,
        closeOnCancel: true
      }, function(isConfirm){
        if (isConfirm) {
          docketService.deleteDocket(docket, function(success) {
            swal("Deleted!", "Docket " + docket.docketNumber + " has been deleted.", "success");
            $scope.loadDocketsIntoList();
          }, function(error) {
            alert('error deleting docket!');
          });
        }
      });
    }

    $scope.sendDocketSwipe = function(docket) {
      docketService.sendDocket(docket, function(success) {
        $scope.loadDocketsIntoList();
      }, function(error) {
        alert('error sending docket!');
      });
    }

    $scope.rejectDocketSwipe = function(docket) {
      docketService.rejectDocket(docket, function(success) {
        $scope.loadDocketsIntoList();
      }, function(error) {
        alert('error rejecting docket!');
      });
    }

    $scope.acceptDocketSwipe = function(docket) {
      docketService.acceptDocket(docket, function(success) {
        $scope.loadDocketsIntoList();
      }, function(error) {
        alert('error accepting docket!');
      });
    }

    $scope.acceptAndFileDocketSwipe = function(docket) {
      docketService.acceptDocket(docket, function(success) {
        $state.go('main.filingDetail', {docketId:docket.id});
      }, function(error) {
        alert('error accepting docket!');
        $scope.showToast('Error Accepting Docket');
      });
    }

    $scope.fileDocketSwipe = function(docket) {
      var url = "/dockets?"
    }

    /***************************************/
    /***** Docket List Filter Controls *****/
    /***************************************/

    $scope.resetDocketFilters = function() {
      $scope.docketFilters = {};
      $scope.docketFilters.otherParty = "All";
      $scope.docketFilters.statusTab = "All";
      $scope.docketFilters.status = "All";
      $scope.docketFilters.organisation = "All";
      $scope.docketFilters.fromDate = moment().subtract(7,'days').toDate();
      $scope.docketFilters.toDate = null;
      $scope.docketFilters.customerGroup = null;
      $scope.docketFilters.supplierGroup = null;
    }

    /**************************/
    /***** Filter Helpers *****/
    /**************************/

    $scope.setDateFilterFromPreset = function(filters, preset) {
      if ( preset == 'today' ) {
        filters.fromDate = new Date();
        filters.toDate = null;
      } else if ( preset == 'yesterday' ) {
        filters.fromDate = moment().add(-1, 'days').toDate();
        filters.toDate = moment().add(-1, 'days').toDate();
      } else if ( preset == 'week' ) {
        filters.fromDate = moment().add(-7,'days').toDate();
        filters.toDate = null;
      }
    }

    $scope.setComplexFilter = function(filterName) {
      if ( filterName == 'sentDockets' ) {
        $scope.filters.statusTab = "Sent";
        $scope.filters.status = "Sent";
        $scope.filters.supplierGroup = $scope.currentOrgGroup.id;
        $scope.filters.customerGroup = null;
      } else if ( filterName == 'recievedDockets' ) {
        $scope.filters.statusTab = "Recieved";
        $scope.filters.status = "Sent";
        $scope.filters.customerGroup = $scope.currentOrgGroup.id;
        $scope.filters.supplierGroup = null;
      } else if ( filterName == 'draftDockets' ){
        $scope.filters.statusTab = "Draft";
        $scope.filters.status = "Draft";
        $scope.filters.customerGroup = null;
        $scope.filters.supplierGroup = null;
      } else if ( filterName == 'acceptedDockets' ) {
        $scope.filters.statusTab = "Accepted";
        $scope.filters.status = "Accepted";
        $scope.filters.customerGroup = null;
        $scope.filters.supplierGroup = null;
      } else if ( filterName == 'rejectedDockets' ) {
        $scope.filters.statusTab = "Rejected";
        $scope.filters.status = "Rejected";
        $scope.filters.customerGroup = null;
        $scope.filters.supplierGroup = null;
      } else if ( filterName == 'allDockets' ) {
        $scope.filters.statusTab = "All";
        $scope.filters.status = "All";
        $scope.filters.customerGroup = null;
        $scope.filters.supplierGroup = null;
      }
    }

    $scope.clearFilterDateSet = function(firstDate, secondDate) {
      $scope.filters[firstDate] = null;
      $scope.filters[secondDate] = null;
    }

    /*******************************/
    /**** Filters Bottom Sheet *****/
    /*******************************/

    $scope.openDocketFiltersSheet = function() {
      $scope.filtersEdit = angular.copy($scope.docketFilters);

      $mdBottomSheet.show({
        templateUrl:'views/pages/dockets/mobile/filterBottomSheet.html',
        scope: $scope,
        preserveScope: true
      }).then(function() {
        // update changed filters
        $scope.docketFilters = $scope.filtersEdit;
        $scope.loadDocketsIntoList();
      },function() {
        // update changed filters
        $scope.docketFilters = $scope.filtersEdit;
        $scope.loadDocketsIntoList();
      });
    }

    /**************************************************************************/
    /**************************************** JOBS ****************************/
    /**************************************************************************/

    /***********************************/
    /***** Jobs List View Controls *****/
    /***********************************/

    // Load Jobs Into List Controller
    $scope.loadJobsIntoList = function() {
      $scope.jobsLoadingError = null;
      $scope.prepareForJobsFromParent();
      $scope.getJobsListFiltered(function(jobsList) {
        var jobsListParsed = jobService.parseJobs(jobsList);
        $scope.loadJobsListFromParent(jobsListParsed);
        $scope.preventJobsLoad = false;
      }, function(err) {
        $scope.jobsLoadingError = err;
        $scope.preventJobsLoad = false;
      });
    }

    // Load more jobs into list
    $scope.loadNextPageOfJobs = function(cb) {
      if ( $scope.preventJobsLoad ) {
        cb();
        return;
      }
      $scope.jobFilters.offset = $scope.jobFilters.offset + $scope.jobFilters.limit;
      // get the next page of dockets
      $scope.getJobsListFiltered(function(jobsList) {
        if ( jobsList.length == 0 ) {
          $scope.preventJobsLoad = true;
          cb();
          return;
        }
        var jobsListParsed = jobService.parseJobs(jobsList);
        $scope.loadAdditionalJobsFromParent(jobsListParsed);
        cb();
        $scope.preventJobsLoad = false;
      });
    }

    // When child (listController) controller is ready - load initial list of jobs
    $scope.jobsChildControllerReady = function() {
      if ( $scope.listView == 'jobs' ) {
        $scope.loadJobsIntoList();
        $scope.bindScrollWatcher();
      }
    }

    $scope.getJobsListFiltered = function(successCb, failureCb) {
      var params = {};
      if ( $scope.jobFilters.startFromDate != null ) {
        var startFromDate = moment($scope.jobFilters.startFromDate);
        startFromDate.set({'hour':'0','minute':'0','second':'1'});
        params.startFromDate = startFromDate.toISOString();
      }
      if ( $scope.jobFilters.startToDate != null ) {
        var startToDate = moment($scope.jobFilters.startToDate);
        startToDate.set({'hour':'23','minute':'59','second':'59'});
        params.startToDate = startToDate.toISOString();
      }
      if ( $scope.jobFilters.endFromDate != null ) {
        var endFromDate = moment($scope.jobFilters.endFromDate);
        endFromDate.set({'hour':'0','minute':'0','second':'1'});
        params.endFromDate = endFromDate.toISOString();
      }
      if ( $scope.jobFilters.endToDate != null ) {
        var endToDate = moment($scope.jobFilters.endToDate);
        endToDate.set({'hour':'23','minute':'59','second':'59'});
        params.endToDate = endToDate.toISOString();
      }
      if ( $scope.jobFilters.customer != 'All' && $scope.jobFilters.customer != null ) {
        params.customer = $scope.jobFilters.customer;
      }
      if ( $scope.jobFilters.assignee != 'All' && $scope.jobFilters.assignee != null ) {
        if ( $scope.jobFilters.assignee == 'Me' ) {
          params.assignee = $scope.currentUser.id;
        } else {
          // generate uuid list of assignees
          var uuidList = [];
          for ( var i = 0; i < $scope.jobFilters.assigneeList.length; i++ ) {
            uuidList.push($scope.jobFilters.assigneeList[i].id);
          }
          params.assignee = uuidList;
        }
      }
      if ( $scope.jobFilters.status != 'All' ) {
        params.status = $scope.jobFilters.status;
      }
      params['sort'] = 'jobNumber';
      params['limit'] = $scope.jobFilters.limit;
      params['offset'] = $scope.jobFilters.offset;

      jobService.getJobs(params, function(response) {
        successCb(response);
        return;
      }, function(err) {
        failureCb("Error Loading Jobs");
        return;
      });
    }

    /****************************/
    /**** Jobs Data Helpers *****/
    /****************************/

    $scope.sendJobSwipe = function(job) {
      jobService.sendJob(job, function(success) {
        $scope.loadJobsIntoList();
      }, function(error) {
        alert('error sending job!');
      });
    }

    $scope.deleteJobSwipe = function(job) {
      jobService.deleteJob(job, function(success) {
        $scope.loadJobsIntoList();
      }, function(error) {
        alert('error deleting job!');
      });
    }

    $scope.assigneeChangeStatusSwipe = function(job, statusTo, method) {
      if ( statusTo == 'Rejected' ) {
        swal({
          title: "Reject Job " + job.jobNumber,
          text: "Please provide a reason for rejecting this job.",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: true,
          inputPlaceholder: "Reason"
        }, function(inputValue){
          if ( inputValue === false ) {
            return;
          }
          jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, inputValue, function(success) {
            // status change successful - reload jobs list
            $scope.showToast('Job Status Updated');
            $scope.loadJobsIntoList();
          }, function(err) {
            $scope.showToast("Job Status Update Failed");
          });
        });
      } else {
        jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, null, function(success) {
          // status change successful - reload jobs list
          $scope.showToast("Job Status Updated");
          $scope.loadJobsIntoList();
        }, function(err) {
          $scope.showToast("Job Status Update Failed");
        });
      }
    }

    /***************************************/
    /***** Docket List Filter Controls *****/
    /***************************************/

    $scope.resetJobFilters = function() {
      $scope.jobFilters = {};
      $scope.jobFilters.status = 'All';
      $scope.jobFilters.startFromDate = null;// moment().subtract(7,'days').toDate();
      $scope.jobFilters.startToDate = null;
      $scope.jobFilters.endFromDate = moment().subtract(7,'days').toDate();
      $scope.jobFilters.endToDate = null;
      $scope.jobFilters.customer = 'All';
      $scope.jobFilters.assignee = 'All';
      $scope.jobFilters.assigneeList = [];
    }

    /*******************************/
    /**** Filters Bottom Sheet *****/
    /*******************************/

    $scope.openJobFiltersSheet = function() {
      $scope.filtersEdit = angular.copy($scope.jobFilters);

      $mdBottomSheet.show({
        templateUrl:'views/pages/jobs/mobile/filterBottomSheet.html',
        scope: $scope,
        preserveScope: true
      }).then(function() {
        // update changed filters
        $scope.jobFilters = $scope.filtersEdit;
        $scope.loadJobsIntoList();
      },function() {
        // update changed filters
        $scope.jobFilters = $scope.filtersEdit;
        $scope.loadJobsIntoList();
      });
    }

    /**************************************************************************/
    /********************************** Orders ********************************/
    /**************************************************************************/

    /*************************************/
    /***** Orders List View Controls *****/
    /*************************************/

    // Load Orders Into List Controller
    $scope.loadOrdersIntoList = function() {
      $scope.ordersLoadingError = null;
      $scope.prepareForOrdersFromParent();
      $scope.getOrdersListFiltered(function(ordersList) {
        var ordersListParsed = orderService.parseOrders(ordersList);
        $scope.loadOrdersListFromParent(ordersListParsed);
        $scope.preventOrdersLoad = false;
      }, function(err) {
        $scope.ordersLoadingError = err;
        $scope.preventOrdersLoad = false;
      });
    }

    // Load more orders into list
    $scope.loadNextPageOfOrders = function(cb) {
      if ( $scope.preventOrdersLoad ) {
        cb();
        return;
      }
      $scope.orderFilters.offset = $scope.orderFilters.offset + $scope.orderFilters.limit;
      // get the next page of orders
      $scope.getOrdersListFiltered(function(ordersList) {
        if ( ordersList.length == 0 ) {
          $scope.preventOrdersLoad = true;
          cb();
          return;
        }
        var ordersListParsed = orderService.parseOrders(ordersList);
        $scope.loadAdditionalOrdersFromParent(ordersListParsed);
        cb();
        $scope.preventOrdersLoad = false;
      });
    }

    // When child (listController) controller is ready - load initial list of orders
    $scope.ordersChildControllerReady = function() {
      if ( $scope.listView == 'orders' ) {
        $scope.loadOrdersIntoList();
        $scope.bindScrollWatcher();
      }
    }

    $scope.getOrdersListFiltered = function(successCb, failureCb) {
      var params = {};
      if ( $scope.orderFilters.startFromDate != null ) {
        var startFromDate = moment($scope.orderFilters.startFromDate);
        startFromDate.set({'hour':'0','minute':'0','second':'1'});
        params.startFromDate = startFromDate.toISOString();
      }
      if ( $scope.orderFilters.startToDate != null ) {
        var startToDate = moment($scope.orderFilters.startToDate);
        startToDate.set({'hour':'23','minute':'59','second':'59'});
        params.startToDate = startToDate.toISOString();
      }
      if ( $scope.orderFilters.endFromDate != null ) {
        var endFromDate = moment($scope.orderFilters.endFromDate);
        endFromDate.set({'hour':'0','minute':'0','second':'1'});
        params.endFromDate = endFromDate.toISOString();
      }
      if ( $scope.orderFilters.endToDate != null ) {
        var endToDate = moment($scope.orderFilters.endToDate);
        endToDate.set({'hour':'23','minute':'59','second':'59'});
        params.endToDate = endToDate.toISOString();
      }
      if ( $scope.orderFilters.status != 'All' ) {
        params.status = $scope.orderFilters.status;
      }
      params['prioritizePending'] = true;
      params['limit'] = $scope.orderFilters.limit;
      params['offset'] = $scope.orderFilters.offset;
      params['sort'] = 'startDate';

      orderService.getOrders(params, function(response) {
        successCb(response);
        return;
      }, function(err) {
        failureCb("Error Getting Orders");
        return;
      });
    }

    /*******************************/
    /***** Orders Data Helpers *****/
    /*******************************/

    $scope.deleteOrderSwipe = function(order) {
      // confirm order deletion before calling to service
      swal({
        title: "Are you sure?",
        text: "You will not be able to recover this order!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel plx!",
        closeOnConfirm: false,
        closeOnCancel: true
      }, function(isConfirm){
        if (isConfirm) {
          orderService.deleteOrder(order, function(success) {
            swal("Deleted!", "Order " + order.orderNumber + " has been deleted.", "success");
            $scope.loadOrdersIntoList();
          }, function(error) {
            alert('error deleting order!');
          });
        }
      });
    }

    /**************************************/
    /***** Order List Filter Controls *****/
    /**************************************/

    $scope.resetOrderFilters = function() {
      $scope.orderFilters = {};
      $scope.orderFilters.status = 'All';
      $scope.orderFilters.startFromDate = null;// moment().subtract(7,'days').toDate();
      $scope.orderFilters.startToDate = null;
      $scope.orderFilters.endFromDate = moment().subtract(7,'days').toDate();
      $scope.orderFilters.endToDate = null;
      $scope.orderFilters.customer = 'All';
      $scope.orderFilters.assignee = 'All';
      $scope.orderFilters.assigneeList = [];
    }

    /*******************************/
    /**** Filters Bottom Sheet *****/
    /*******************************/

    $scope.openOrderFiltersSheet = function() {
      $scope.filtersEdit = angular.copy($scope.orderFilters);

      $mdBottomSheet.show({
        templateUrl:'views/pages/orders/mobile/filterBottomSheet.html',
        scope: $scope,
        preserveScope: true
      }).then(function() {
        // update changed filters
        $scope.orderFilters = $scope.filtersEdit;
        $scope.loadOrdersIntoList();
      },function() {
        // update changed filters
        $scope.orderFilters = $scope.filtersEdit;
        $scope.loadOrdersIntoList();
      });
    }

    /*************************************************************************/
    /********************************** Filing *******************************/
    /*************************************************************************/

    /*************************************/
    /***** Filing List View Controls *****/
    /*************************************/

    // Load Filing Dockets Into List Controller
    $scope.loadFilingIntoList = function() {
      $scope.prepareForFilingListFromParent();
      $scope.getFilingListFiltered(function(filingList) {
        $scope.populateDocketFiles(filingList, function(filingListPopulated) {
          var filingListParsed = docketService.parseDocketsForFiling(filingListPopulated, $scope.filingFilters.statusTab.toLowerCase());
          $scope.loadDocketFilingListFromParent(filingListParsed);
          $scope.preventFilingLoad = false;
        });
      }, function(err) {
        $scope.filingLoadingError = err;
        $scope.preventFilingLoad = false;
      });
    }

    // Load more docket files into list
    $scope.loadNextPageOfFiling = function(cb) {
      if ( $scope.preventFilingLoad ) {
        cb();
        return;
      }
      $scope.filingFilters.offset = $scope.filingFilters.offset + $scope.filingFilters.limit;
      // get the next page of dockets
      $scope.getFilingListFiltered(function(filingList) {
        $scope.populateDocketFiles(filingList, function(filingListPopulated) {
          if ( filingListPopulated.length == 0 ) {
            $scope.preventFilingLoad = true;
            cb();
            return;
          }
          var filingListParsed = docketService.parseDocketsForFiling(filingListPopulated, $scope.filingFilters.statusTab.toLowerCase());
          $scope.loadAdditionalDocketFilingFromParent(filingListPopulated);
          cb();
          $scope.preventFilingLoad = false;
        });
      });
    }

    // When child (listController) controller is ready - load initial list of dockets
    $scope.filingsChildControllerReady = function() {
      if ( $scope.listView == 'filing' ) {
        $scope.loadFilingIntoList();
        $scope.bindScrollWatcher();
      }
    }

    // Get dockets for filing
    $scope.getFilingListFiltered = function(successCb, failureCb) {
      var params = {};
      if ( $scope.filingFilters.fromDate != null ) {
        var fromDate = moment($scope.filingFilters.fromDate);
        fromDate.set({'hour':'0','minute':'0','second':'1'});
        params.fromDate = fromDate.toISOString();
      }
      if ( $scope.filingFilters.toDate != null ) {
        var toDate = moment($scope.filingFilters.toDate);
        toDate.set({'hour':'23','minute':'23','second':'59'});
        params.toDate = toDate.toISOString();
      }
      //params.status = 'accepted';
      params['sort'] = 'date';
      params['limit'] = $scope.filingFilters.limit;
      params['offset'] = $scope.filingFilters.offset;

      docketService.getDockets(params, function(response) {
        successCb(response);
      }, function(err) {
        failureCb("Error Loading Dockets");
      });
    }

    /*******************************/
    /***** Filing Data Helpers *****/
    /*******************************/

    $scope.populateDocketFiles = function(docketList, cb) {
      var index = 0;
      $scope.populateDocketListWithFiles(docketList, index, function() {
        cb(docketList);
      });
    };

    $scope.populateDocketListWithFiles = function(docketList, index, cb) {
      if ( index >= docketList.length ) {
        cb();
        return;
      }

      // populate this index of the docketList
      $scope.populateDocketFileData(docketList[index], function(){
        // go to next index
        $scope.populateDocketListWithFiles(docketList, index + 1, cb);
      });
    }

    $scope.populateDocketFileData = function(docket, cb) {
      docketService.getDocketFileData(docket, function(docketFile) {
        docket.existingDocketFile = docketFile;
        cb();
      }, function(err) {
        docket.existingDocketFile = null;
        cb();
      });
    }

    /***************************************/
    /***** Docket List Filter Controls *****/
    /***************************************/

    $scope.resetFilingFilters = function() {
      $scope.filingFilters.status = "accepted";
      $scope.filingFilters.fromDate = moment().subtract(7,'days').toDate();
      $scope.filingFilters.toDate = null;
      $scope.filingFilters.statusTab = "All";
    }

    /*******************************/
    /**** Filters Bottom Sheet *****/
    /*******************************/

    $scope.openFilingFiltersSheet = function() {
      $scope.filtersEdit = angular.copy($scope.filingFilters);

      $mdBottomSheet.show({
        templateUrl:'views/pages/filing/mobile/filterBottomSheet.html',
        scope: $scope,
        preserveScope: true
      }).then(function() {
        // update changed filters
        $scope.filingFilters = $scope.filtersEdit;
        $scope.loadFilingIntoList();
      },function() {
        // update changed filters
        $scope.filingFilters = $scope.filtersEdit;
        $scope.loadFilingIntoList();
      });
    }

    /********************************/
    /***** Opening Detail Items *****/
    /********************************/

    $scope.openDocketDetail = function(docket) {
      if ( $scope.currentOrg != null ) {
        $state.go('main.groupDocketDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, docketId:docket.id});
      } else {
        // look through accessControl to find an organisation that can open this docket
        var accessKeys = Object.keys(docket.accessControl);
        var allowedOrganisations = accessControl.allowedOrganisations();
        var orgId = null;
        var groupId = null;
        var secondaryOrgs = [];
        for ( var i = 0; i < allowedOrganisations.length; i++ ) {
          for ( var j = 0; j < allowedOrganisations[i].groups.length; j++ ) {
            for ( var k = 0; k < allowedOrganisations[i].groups[j].emailAddresses.length; k++ ) {
              for ( var l = 0; l < accessKeys.length; l++ ) {
                if ( accessKeys[l] == allowedOrganisations[i].groups[j].emailAddresses[k] ) {
                  if ( docket.accessControl[accessKeys[l]].indexOf('creator') != -1 ) {
                    orgId = allowedOrganisations[i].id;
                    groupId = allowedOrganisations[i].groups[j].id;
                    break;
                  } else {
                    secondaryOrgs.push({orgId: allowedOrganisations[i].id, groupId: allowedOrganisations[i].groups[j].id});
                  }
                }
              }
            }
          }
        }
        if ( orgId && groupId ) {
          $state.go('main.groupDocketDetail', {orgId:orgId, groupId:groupId, docketId:docket.id});
        } else if ( secondaryOrgs && secondaryOrgs.length > 0 ) {
          $state.go('main.groupDocketDetail', {orgId:secondaryOrgs[0].orgId, groupId:secondaryOrgs[0].groupId, docketId:docket.id});
        } else {
          $state.go('main.docketDetail', {docketId:docket.id});
        }
      }
    }

    $scope.openJobDetail = function(job) {
      if ( $scope.currentOrg != null ) {
        $state.go('main.groupJobDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, jobId:job.id});
      } else {
        // determine org and group to open the job inside of
        if ( job.userAssigneeData != null && job.userAssigneeData.organisation != null && job.userAssigneeData.organisationGroup != null ) {
          $state.go('main.groupJobDetail', { jobId: job.id, orgId: job.userAssigneeData.organisation, groupId: job.userAssigneeData.organisationGroup });
        } else {
          $state.go('main.jobDetail', { jobId : job.id });
        }
      }
    }

    $scope.openOrderDetail = function(order) {
      if ( $scope.currentOrg != null ) {
        $state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId:order.id});
      } else {
        $state.go('main.orderDetail', { orderId : order.id });
      }
    }

    $scope.openHelpLink = function() {
      window.open("https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us");
    }

    /**************************************************************************/
    /******************************** Other Helpers ***************************/
    /**************************************************************************/

    /*****************************/
    /***** Date/Time Pickers *****/
    /*****************************/

    $scope.showDatePicker = function(field, ev) {
      $mdpDatePicker($scope.itemEdit[field], {
        targetEvent: ev
      }).then(function(selectedDate) {
        $scope.itemEdit[field] = selectedDate;
      });
    }

    $scope.showTimePicker = function(field, ev) {
      $mdpTimePicker($scope.itemEdit[field], {
        targetEvent: ev,
        autoSwitch: true
      }).then(function(selectedTime) {
        $scope.itemEdit[field] = selectedTime;
      });
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function(message) {
      var toast = {};
      if ( $stateParams.device == 'desktop' ) {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /****************************/
    /***** Mobile Nav Setup *****/
    /****************************/

    var tab = "";
    if ( $scope.listView == 'dockets' ) {
      tab = "#navDocketsTab";
    } else if ( $scope.listView == 'orders' ) {
      tab = "#navOrdersTab";
    } else if ( $scope.listView == 'jobs' ) {
      tab = "#navJobsTab";
    } else if ( $scope.listView == 'filing' ) {
      tab = "#navFilingTab";
    }

    if ( $(tab).offset() ) {
      var leftOffset = $(tab).offset().left + $(tab).width();
      var width =  $(".tabBarMobile.mainNavBar").width();
      var M = width / 2;
      var Y = leftOffset;
      var X = $(".tabBarMobile.mainNavBar").scrollLeft();

      if ( Y > M ) {
        // scroll right
        $(".tabBarMobile.mainNavBar").animate({scrollLeft:X+(Y-M)}, 600);
      } else {
        // scroll left
        $(".tabBarMobile.mainNavBar").animate({scrollLeft:X-(M-Y)}, 600);
      }
    }

    /**************************************/
    /***** Infinite Scrolling Methods *****/
    /**************************************/

    $scope.loadingMoreItems = false;
    $scope.docketsListLoadingCount = 0;
    $scope.bindScrollWatcher = function() {
      angular.element($window).on('scroll', function() {
        if ( $(window).scrollTop() + $(window).height() > $(document).height() - 20 ) {
          if ( $scope.listView == 'dockets' ) {
            $scope.scrollLoadDockets();
          } else if ( $scope.listView == 'jobs' ) {
            $scope.scrollLoadJobs();
          } else if ( $scope.listView == 'orders' ) {
            $scope.scrollLoadOrders();
          } else if ( $scope.listView == 'filing' ) {
            $scope.scrollLoadDocketFiles();
          }
        }
      });
    }

    $scope.scrollLoadDocketFiles = function() {
      if ( !$scope.loadingMoreItems && !$scope.preventFilingLoad ) {
        $scope.loadingMoreItems = true;
        $("#filingLoadingMore").removeClass('hidden');
        $scope.loadNextPageOfFiling(function() {
          $scope.loadingMoreItems = false;
          $("#filingLoadingMore").addClass("hidden");
        });
      }
    }

    $scope.scrollLoadDockets = function() {
      if ( !$scope.loadingMoreItems && !$scope.preventDocketsLoad ) {
        $scope.loadingMoreItems = true;
        $("#docketsLoadingMore").removeClass('hidden');
        $scope.loadNextPageOfDockets(function() {
          $scope.loadingMoreItems = false;
          $("#docketsLoadingMore").addClass("hidden");
        });
      }
    }

    $scope.scrollLoadJobs = function() {
      if ( !$scope.loadingMoreItems && !$scope.preventJobsLoad ) {
        $scope.loadingMoreItems = true;
        $("#jobsLoadingMore").removeClass('hidden');
        $scope.loadNextPageOfJobs(function() {
          $scope.loadingMoreItems = false;
          $("#jobsLoadingMore").addClass("hidden");
        });
      }
    }

    $scope.scrollLoadOrders = function() {
      if ( !$scope.loadingMoreItems && !$scope.preventOrdersLoad ) {
        $scope.loadingMoreItems = true;
        $("#ordersLoadingMore").removeClass('hidden');
        $scope.loadNextPageOfOrders(function() {
          $scope.loadingMoreItems = false;
          $("#ordersLoadingMore").addClass("hidden");
        });
      }
    }
});



// WEBPACK FOOTER //
// ./src/controllers/mobileListController.js